import { isString } from "./is-string";
const RE = /^#([a-f0-9]{3}|[a-f0-9]{4}(?:[a-f0-9]{2}){0,2})$/i;
export const isHexColor = (x) => isString(x) && RE.test(x);
